import { Box, Stack, Typography } from '@mui/material';
import classNames from 'classnames';
import cmStyles from '/@/components/crop-monitoring/cards/styles.module.css';
import { _ } from '/@/locale';
import type { CropMonitoring } from '/@/types/crop-monitoring';
import CropMonitoringDetailCard from '../detail-card';
import { getLabelStep } from '../progress-bar/assets/BASE_STEPS';
import Ground from './assets/ground.svg';

function FieldStatusStage({ cropMonitoring }: { cropMonitoring: CropMonitoring }) {
    const lastStage = cropMonitoring?.cornCropMonitoring?.stages?.at(-1);
    const isFallow = (cropMonitoring?.cornCropMonitoring?.accumulatedGdu || 0) === 0;

    const STAGES = {
        'sowing-emergence': _('Siembra-Emergencia'),
        'emergence-flowering': _('Emergencia-Vegetativo'),
        'flowering-maturity': _('Floración-Madurez'),
    };

    return (
        <Stack alignItems='center' textAlign='center'>
            <Typography
                color='primary'
                variant='subtitle1'
                sx={{
                    fontWeight: 700,
                }}
            >
                {isFallow ? _('Estado del lote') : _('Etapa del cultivo')}
            </Typography>
            <Typography
                color='primary'
                variant='h4'
                sx={{
                    fontWeight: 100,
                    fontStyle: 'italic',
                }}
            >
                {isFallow ? _('Barbecho') : getLabelStep(lastStage?.vegetativeStage, lastStage?.phenology)}
            </Typography>
            <Typography
                color='primary.mui.inactive'
                variant='caption'
                sx={{
                    fontWeight: 400,
                }}
            >
                {isFallow ? _('Período de descanso') : `GDUs ${cropMonitoring?.cornCropMonitoring?.accumulatedGdu}`}
            </Typography>

            {!isFallow && lastStage !== undefined && (
                <Box
                    className={classNames(
                        cmStyles.plants,
                        cmStyles[lastStage?.phenology || `v-${lastStage?.vegetativeStage}`]
                    )}
                    sx={{
                        height: {
                            xs: '200px !important',
                        },
                        width: '100% !important',
                    }}
                />
            )}

            {lastStage?.vegetativeStage && (
                <Typography
                    color='primary.mui.disabled'
                    variant='caption'
                    sx={{
                        fontWeight: 400,
                    }}
                >
                    {_('Vegetativo')}
                </Typography>
            )}
            <Typography
                color='primary.mui.inactive'
                variant='caption'
                sx={{
                    fontWeight: 400,
                }}
            >
                {STAGES[cropMonitoring?.cornCropMonitoring?.currentStage as keyof typeof STAGES]}
            </Typography>
        </Stack>
    );
}

export default function FieldStatus({ cropMonitoring }: { cropMonitoring: any }) {
    const backgroundImage = Ground;

    return (
        <CropMonitoringDetailCard
            title={_('Estado actual del lote')}
            subtitle={_('Momento del lote y evolución de cultivos')}
        >
            <Stack
                data-testid='field-status-stack'
                sx={{
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: '100%',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'bottom',
                    padding: 3,

                    height: '100%',
                    justifyContent: 'center',
                }}
            >
                <FieldStatusStage cropMonitoring={cropMonitoring} />
            </Stack>
        </CropMonitoringDetailCard>
    );
}
